// --- Core ---
import {get, set} from "local-storage";
// --- SaniQ ---
import * as MeasurementsConstants from '../constants';
import {PatientDrugIntake} from "../../../../../models/patient/drug/Intake";
import {PatientNotice} from "../../../../../models/patient/PatientNotice";
import {LS_MEASUREMENTS_DIARY_TYPE} from "shared/constants/LocalStorage";
import {MeasurementKey} from "vendor/qurasoft/definitions/types/measurements";

interface MeasurementsState {
  drugIntakes: PatientDrugIntake[];
  drugIntakesIsLoading: boolean;
  drugIntakesPatientId: null | string;
  patientNotices: PatientNotice[];
  patientNoticesIsLoading: boolean;
  patientNoticesPatientId: null | string;
  diaryType: Record<string, MeasurementKey>;
}

const initialState: MeasurementsState = {
  drugIntakes: [],
  drugIntakesIsLoading: false,
  drugIntakesPatientId: null,
  patientNotices: [],
  patientNoticesIsLoading: false,
  patientNoticesPatientId: null,
  diaryType: get(LS_MEASUREMENTS_DIARY_TYPE) || {'-1': 'pef'}
};

export function measurements(state = initialState, action) {
  switch (action.type) {
    case MeasurementsConstants.PATIENT_MEASUREMENT_DIARY_TYPE_CHANGED: {
      const newDiaryType = {...state.diaryType};
      newDiaryType[action.patientId] = action.diaryType;
      set(LS_MEASUREMENTS_DIARY_TYPE, newDiaryType);
      return state;
    }
    case MeasurementsConstants.PATIENT_DRUG_INTAKES_FETCH_STARTED:
      return Object.assign({}, state, {drugIntakesIsLoading: true, drugIntakesPatientId: action.patientId});
    case MeasurementsConstants.PATIENT_MEASUREMENT_DRUG_INTAKES_FETCH_COMPLETED:
      return Object.assign({}, state, {
        drugIntakes: action.intakes,
        drugIntakesIsLoading: false
      });
    case MeasurementsConstants.PATIENT_DRUG_INTAKES_CLEAR:
      return Object.assign({}, state, {drugIntakes: initialState.drugIntakes, drugIntakesPatientId: null});
    case MeasurementsConstants.PATIENT_NOTICES_FETCH_STARTED:
      return Object.assign({}, state, {patientNoticesIsLoading: true, patientNoticesPatientId: action.patientId});
    case MeasurementsConstants.PATIENT_NOTICES_FETCH_COMPLETED:
      return Object.assign({}, state, {
        patientNotices: action.notices,
        patientNoticesIsLoading: false
      });
    case MeasurementsConstants.PATIENT_NOTICES_CLEAR:
      return Object.assign({}, state, {patientNotices: initialState.patientNotices, patientNoticesPatientId: null});
    default:
      return state;
  }
}
